import _get from 'lodash/get';
import { Cookies } from 'react-cookie';
import { extractErrorMessage, genID } from 'ravenjs/utils';
import { toast } from 'ravenjs/lib';
import { REDIS_VALUE } from 'constants/acaReporting';
import { EVENTS } from 'constants/events';

const cookies = new Cookies();
const year = new Date().getFullYear() - 1;

/**
 * Handles the full PCORI SSO redirect flow:
 * 1. Fetches company additional data
 * 2. Stores tax year in Redis with PCORI suffix
 * 3. Send Pendo event for tracking
 * 4. Opens HRLogics SSO in a new tab
 *
 * @param {Object} params
 * @param {number} params.companyId
 * @param {Function} params.fetchCompanyAdditionalData
 * @param {Function} params.setAcaTaxYearInRedis
 * @param {Function} params.sendPendoEvent
 * @param {Function} params.isLoading
 */

export const handlePCORISsoRedirect = async ({
    companyId,
    fetchCompanyAdditionalData,
    setAcaTaxYearInRedis,
    sendPendoEvent,
    isLoading,
}) => {
    isLoading(true);
    try {
        const response = await fetchCompanyAdditionalData(companyId);
        const companyAdditionalData = _get(response, 'companyAdditionalData[0]', {});
        const { data: { uhcCompanyId = '', externalCompanyId = '' } = {} } = companyAdditionalData;

        const id = externalCompanyId || uhcCompanyId || companyId;
        await setAcaTaxYearInRedis({
            data: {
                value: `${year};${id};${companyId};${REDIS_VALUE.PCORI}`,
            },
        });

        const baseEvent = EVENTS.HR_LOGICS.PCORI_REPORTING_TOOL_LINK_CLICK;
        const redirect_id = genID();
        cookies.set('redirect_id', redirect_id, {
            path: '/',
            secure: true,
            sameSite: 'None',
        });
        const pendoEvent = {
            ...baseEvent,
            eventProperties: {
                ...baseEvent.eventProperties,
                companyId,
            },
            context: {
                ...baseEvent.context,
                url: `${window.location.origin}/hr-tools/aca-reporting/HRLogics?redirect_id=${redirect_id}`,
            },
        };
        if (typeof sendPendoEvent === 'function') {
            sendPendoEvent(pendoEvent);
        }
        window.open(`/hr-tools/aca-reporting/HRLogics?redirect_id=${redirect_id}`, '_blank');
    } catch (error) {
        toast.error(extractErrorMessage(error));
    } finally {
        isLoading(false);
    }
};
